import { render, staticRenderFns } from "./more-detail.vue?vue&type=template&id=03648ebe&"
import script from "./more-detail.vue?vue&type=script&lang=js&"
export * from "./more-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports